// extracted by mini-css-extract-plugin
module.exports = {"root":"auth_root__1unyW","form":"auth_form__2AGU9","title":"auth_title__1TBwP"};